<ng-container *ngIf="!aceptaElegirCategoria">
  <header class="modal-header modal-bg">
    <div class="row">
      <img
      src="../../../../../assets/icons/interrogation-icon.png"
      class="img-fluid px-5 my-3 mx-auto"
      />
    </div>
    <div class="col-12">
      <h2 class="text-center">
       {{titulo}}
      </h2>
    </div>
    
  </header>
  <section class="modal-body text-center px-5 my-3">
    <div [innerHTML]="mensaje"></div>
  </section>
  <footer class="modal-footer justify-content-center">
    <button
      class="btn"
      (click)="cancel()"
      [disabled]="esObligatorio"
      *ngIf="!esObligatorio"
    >
      Abandonar
    </button>
    <button class="btn" (click)="confirm()">Continuar</button>
  </footer>
</ng-container>

<div class="modal-body" *ngIf="aceptaElegirCategoria">
  <div class="row m-3">
    <div class="col-12">
      <p>
        Seleccione la categoría y la subcategoría por la que va a hacer el
        cambio
      </p>
    </div>
    <div class="col-12 col-md-6">
      <select
        class="form-control"
        [(ngModel)]="nuevaCategoria"
        (ngModelChange)="onChangeCategoria()"
      >
        <option [ngValue]="null" selected="true">
          Seleccione una nueva categoría
        </option>
        <ng-container *ngFor="let item of nuevasCategorias">
          <option [ngValue]="item">
            {{ item.descripcion }}
          </option>
        </ng-container>
      </select>
    </div>
    <div class="col-12 col-md-6" *ngIf="subcategorias?.length > 0">
      <select class="form-control" [(ngModel)]="subcategoria">
        <option [ngValue]="null" selected="true">
          Seleccione una nueva subcategoría
        </option>
        <ng-container *ngFor="let item of subcategorias">
          <option [ngValue]="item">
            {{ item.descripcion }}
          </option>
        </ng-container>
      </select>
    </div>
  </div>
  <div class="col-12 text-right">
    <button
      class="btn mr-3"
      (click)="cancel()"
      [disabled]="esObligatorio"
      *ngIf="!esObligatorio"
    >
      Cancelar
    </button>
    <button class="btn" (click)="confirmConDatos()">Continuar</button>
  </div>
</div>
